
import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { Cell, Table } from '@/main/utils/table';

import { NAME as name, CRUMB_LABEL_EDIT, PROrdersParts, DEPENDENT_TABLES as depTableNames } from '../constants';
import { apiProvider } from '../api';
import { editMutations, HromadnaObjednavka } from './types';


const dropdownList = {
	PrOrderStatusId: [],
	SkladOzn: [],
	OrderType: [],
	VyrobekndOzn: [],
	Parts: [],
	OdpovedPzn: [],
	PohledavkaPzn: [],
	WarehouseId: [],
	VydejMjId: [],
	DefaultPartsList: [],
	BillToWarehouseList: [],
};
const edit = {
	VyrazenPrp: null as boolean | null,
	SkladOzn: null as number | null,
	OrderNo: null as number | null,
	WarehouseId: null as number | null,
	Id: 0 as number,
	CreatedById: null as string | null,
	LastUpdatedById: null as string | null,
	StatusUpdatedBy: null as string | null,
	PrOrderStatusId: null as number | null,
	StatusId: 0 as number,
	SkladmistoIdSkladmisto: null as string | null,
	SkladmistoIdPopis: null as string | null,
	VstupDat: null as string | null,
	VstupPracId: null as number | null,
	VstupPracIdText: null as string | null,
	EditDat: null as string | null,
	EditPracId: null as number | null,
	EditPracIdText: null as string | null,
	MioNr: null as number | null,
	Remarks: null as string | null,
	HideApprovalFlag: true as boolean | null,
	HideApprovalCancelFlag: true as boolean | null,
	DodavatelId: null as number | null,
	DodavatelIdText: null as string | null,
	MioId: null as number | null,
	EmailStatusFlag: null as number | null,
	DisableStatusdrp: null as boolean | null,
	HideApprovalDropdownFlag: null as boolean | null,
	ShowClosePR: false as boolean | null,
	PROrderNr: null as number | null,
	PROrderPfx: null as string | null,
	IsDisableAddPart: false as boolean | null,
	DisableApprovalFlag: false as boolean | null,
	ShowCreatePartsButton: false as boolean | null,
	ShowCancelButton: false as boolean | null,
	ShowSubmitButton: false as boolean | null,
	ShowPrintButton: false as boolean | null,
	IsDealer: false as boolean | null,
	DealerId: null as number | null,
	DealerName: null as string | null,
	OrderType: null as string | null,
	VydejMjId: null as number | null,
	DisableSubmit: false as boolean | null,
	IsFileUploaded: false as boolean | null,
	BillToWarehouseId: null as number | null,
	ShipToWarehouse: null as string | null,
};
const localState = {
	isNdNrChosen: null as boolean | null,
	DisponibilitaSklad: new Table() as Table,
	selectedRow: null as Cell[] | null,
};

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_EDIT,
	dropdownList,
	edit,
	localState,
	depTableNames,
	depTableSettings: {
		[PROrdersParts]: {
			filter(state) {
				return {
					Id: state.edit.Id, DodavatelId: state.edit.DodavatelId, wantRows: true,
				};
			},
			isEditable: true,
			columns: {
				SHIP_TO_WH: { isEditable: true, required: false, type: 'text', minWidth: '170px' },
				X_VYROBEKND_OZN: { isEditable: true, required: true, type: 'dropdown', minWidth: '150px' },
				ND_NR: { isEditable: true, required: true, type: 'dropdown', minWidth: '180px' },
				DISCOUNT: { isEditable: true, required: false, type: 'number', minWidth: '180px' },
				TEXT: { isEditable: true, required: false, type: 'text', minWidth: '130px' },
				REMARK: { isEditable: true, required: false, type: 'text', minWidth: '130px' },
				BASE_UNIT_OF_MEASUREMENT: { isEditable: false, required: false, type: 'text', minWidth: '130px' },
				CONVERTED_UNIT_OF_MEASUREMENT: { isEditable: false, required: false, type: 'text', minWidth: '130px' },
				MNOZSTVI_OBJ: { isEditable: true, required: true, type: 'number', minWidth: '130px' },
				CONVERTED_QUANITY: { isEditable: true, required: false, type: 'number', minWidth: '130px' },
				ODPOVED_PZN: { isEditable: true, required: false, type: 'dropdown', minWidth: '130px' },
				POHLEDAVKA_PZN: { isEditable: true, required: false, type: 'dropdown', minWidth: '130px' },
				TOTAL_COST_PRICE_WITH_VAT: { isEditable: false, required: false, type: 'text', minWidth: '100px' },
				COST_PRICE_WITH_VAT: { isEditable: false, required: false, type: 'text', minWidth: '100px' },
			},
		},

	},
	extraActions: {

	},
	extraGetters: {},
	extraMutations: {
		[editMutations.PR_ORDERS_DODAVATEL_SELECT_MAPPER](state, { data }) {
			state.edit.DodavatelId = data.value;
			state.edit.DodavatelIdText = data.text;
		},
		[editMutations.PR_ORDERS_DEALER_SELECT_MAPPER](state, { data }) {
			state.edit.DealerId = data.value;
			state.edit.DealerName = data.text;
		},
	},
	props: {
		filter: {
			Id: null as number | null,
			MioPzn: null as number | null,
			NdNr: null as string | null,
			Kontrola: null as boolean | null,
			MioId: null as number | null,
			DodavatelId: null as number | null,
			OrderType: null as number | null,
			WarehouseId: null as number | null,
			IsPrOrder: false as boolean | false,
		},
		mode: null,
		jfnd: null as HromadnaObjednavka | null,
	},
});
